var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4531 6.9375H15.375V6.375C15.375 6.16791 15.2071 6 15 6C14.7929 6 14.625 6.16791 14.625 6.375V6.9375H9.375V6.375C9.375 6.16791 9.20712 6 9 6C8.79288 6 8.625 6.16791 8.625 6.375V6.9375H7.54688C6.69391 6.9375 6 7.63141 6 8.48438V16.4531C6 17.3061 6.69391 18 7.54688 18H16.4531C17.3061 18 18 17.3061 18 16.4531V8.48438C18 7.63141 17.3061 6.9375 16.4531 6.9375ZM7.54688 7.6875H8.625V8.0625C8.625 8.26959 8.79288 8.4375 9 8.4375C9.20712 8.4375 9.375 8.26959 9.375 8.0625V7.6875H14.625V8.0625C14.625 8.26959 14.7929 8.4375 15 8.4375C15.2071 8.4375 15.375 8.26959 15.375 8.0625V7.6875H16.4531C16.8925 7.6875 17.25 8.04497 17.25 8.48438V9.375H6.75V8.48438C6.75 8.04497 7.10747 7.6875 7.54688 7.6875ZM16.4531 17.25H7.54688C7.10747 17.25 6.75 16.8925 6.75 16.4531V10.125H17.25V16.4531C17.25 16.8925 16.8925 17.25 16.4531 17.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.9e10c74c7e18ffdd49f018dd9497f1b8.svg";
export { ForwardRef as ReactComponent };